import { Component, inject, Input, OnInit } from '@angular/core';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import { ModeControlMultipleComponent } from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { ModeControlSimpleComponent } from '../../../../../../../../components/ecosystems/mode-control-simple/mode-control-simple.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SelectTimerControlComponent } from '../../../../../../../../components/ecosystems/select-timer-control/select-timer-control.component';
import { getColorDescriptor } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { P00039WelticoV2ColorChoiceComponent } from '../../../Eclairage/components/p00039-weltico-v2-color-choice/p00039-weltico-v2-color-choice.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00039-couverture-controle',
  templateUrl: './p00039-couverture-controle.component.html',
  styleUrls: ['./p00039-couverture-controle.component.scss'],
  imports: [
    IonLabel,
    ModeControlMultipleComponent,
    ModeControlSimpleComponent,
    TranslatePipe,
  ],
})
export class P00039CouvertureControleComponent implements OnInit {
  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
